(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-video-toggle]').forEach(function(wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;

      wrap.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          wrap.classList.add('is-playing');
        } else {
          video.pause();
          wrap.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', function() {
        wrap.classList.remove('is-playing');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambassador-page"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-ambassador]');
    if (!section) return;
    var ref = section.dataset.ref;
    if (!ref) return;

    try {
      var STORAGE_KEY = 'nuho_kol_ref';
      var now = Date.now();
      /* Last-touch wins on ambassador page entry */
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: ref.toUpperCase(), ts: now }));
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-v3"]) return;
  try {
    
  (function() {
    var body = document.getElementById('art-body');
    var tocList = document.getElementById('art-toc-list');
    if (!body || !tocList) return;

    /* === Article rendering enhancements ===
       1. Promote "<p><strong>N. Title...</strong></p>" pseudo-headings into real <h2>
       2. Transform wide (5+ col) tables into nutrient-card lists for all viewports
       3. Style "Note:" italic blocks as callout quotes (auto, via CSS)
    */

    /* 1. Pseudo-heading → h2 promotion (any short bold-only paragraph) */
    body.querySelectorAll('p').forEach(function(p) {
      if (p.children.length !== 1) return;
      var strong = p.firstElementChild;
      if (!strong || strong.tagName !== 'STRONG') return;
      var text = (strong.textContent || '').trim();
      /* Match short bold-only paragraphs that are clearly headings : */
      /* - not too long (<110 chars), not ending in ':' or '.', */
      /* - starts with capital letter / number / roman */
      if (text.length < 110 && text.length >= 3 &&
          !text.endsWith(':') && !text.endsWith('.') && !text.endsWith(',') &&
          /^[A-ZÀ-ÚIVX0-9]/.test(text)) {
        var h2 = document.createElement('h2');
        h2.textContent = text;
        p.parentNode.replaceChild(h2, p);
      }
    });

    /* 2. Wrap + transform tables */
    body.querySelectorAll('table').forEach(function(t) {
      if (t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('table-wrap')) return;
      var headers = Array.from(t.querySelectorAll('thead th')).map(function(h) {
        return (h.textContent || '').trim().replace(/\s+/g, ' ');
      });
      var wrap = document.createElement('div');
      wrap.className = 'table-wrap';
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
      if (headers.length === 0) return;
      /* Wide tables (5+ cols) → transform every viewport into nutrient cards */
      if (headers.length >= 5) {
        wrap.classList.add('table-wrap--nutrient-cards');
        var cards = document.createElement('div');
        cards.className = 'nutrient-cards';
        t.querySelectorAll('tbody tr').forEach(function(tr) {
          var cells = Array.from(tr.children).map(function(td) {
            return td.innerHTML.trim();
          });
          if (cells.every(function(c) { return c === ''; })) return;
          /* Section divider row: only 1 cell has content (rest empty) — render as section heading, NOT a card */
          var nonEmpty = cells.filter(function(c) { return c !== ''; });
          if (nonEmpty.length === 1 && cells[0]) {
            var sectionTitle = document.createElement('h3');
            sectionTitle.className = 'nutrient-cards__section';
            sectionTitle.innerHTML = cells[0];
            cards.appendChild(sectionTitle);
            return;
          }
          /* Normal data row → card */
          var card = document.createElement('article');
          card.className = 'nutrient-card';
          var name = cells[0] || '';
          var rest = cells.slice(1, -1);
          var description = cells[cells.length - 1] || '';
          var statsHtml = '';
          rest.forEach(function(val, i) {
            var label = headers[i + 1] || '';
            if (!val) return;
            statsHtml += '<div class="nc__stat"><span class="nc__label">' + label + '</span><span class="nc__value">' + val + '</span></div>';
          });
          card.innerHTML =
            '<h4 class="nc__name">' + name + '</h4>' +
            (statsHtml ? '<div class="nc__stats">' + statsHtml + '</div>' : '') +
            (description ? '<div class="nc__role">' + description + '</div>' : '');
          cards.appendChild(card);
        });
        if (cards.children.length > 0) {
          /* Insert cards block before the wrap, hide the wrap */
          wrap.parentNode.insertBefore(cards, wrap);
          wrap.style.display = 'none';
        }
      } else if (headers.length >= 4) {
        /* 4-col tables → mobile card layout */
        t.querySelectorAll('tbody tr').forEach(function(tr) {
          Array.from(tr.children).forEach(function(td, idx) {
            if (headers[idx]) td.setAttribute('data-label', headers[idx]);
          });
        });
        wrap.classList.add('table-wrap--cards-mobile');
      }
    });

    /* (dropcap removed: triggered on titles and looked broken — keep first paragraph plain) */

    var headings = body.querySelectorAll('h2');
    var layout = document.querySelector('.art__layout');
    if (headings.length < 2) {
      // No TOC needed — hide sidebar, layout stays single-column (CSS default)
      var toc = document.getElementById('art-toc');
      if (toc) toc.style.display = 'none';
      return;
    }
    // ≥2 h2 headings — enable 2-column layout with TOC sidebar
    if (layout) layout.classList.add('art__layout--with-toc');
    headings.forEach(function(h, i) {
      var slug = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section-' + i;
      h.id = slug;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + slug;
      a.textContent = h.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    });
    /* Scroll-spy */
    var links = tocList.querySelectorAll('a');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          links.forEach(function(l) { l.classList.toggle('active', l.getAttribute('href') === '#' + id); });
        }
      });
    }, { rootMargin: '-100px 0px -60% 0px' });
    headings.forEach(function(h) { observer.observe(h); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["backup-product-v2-20260829-avant-avis-i18n"]) return;
  try {
    
  (function() {
    /* Quantity +/- with price update */
    function updateAtcPrice() {
      var atcBtn = document.querySelector('[data-atc-btn]');
      if (!atcBtn) return;
      var unitPrice = parseInt(atcBtn.getAttribute('data-unit-price'), 10);
      var qtyInput = document.querySelector('[data-pdp-qty]');
      var qty = parseInt(qtyInput.value) || 1;
      var total = unitPrice * qty;
      var rounded = Math.round(total / 100);
      var s = 'CHF ' + rounded + '.–';
      var label = atcBtn.textContent.split('\u2014')[0].trim();
      atcBtn.textContent = label + ' \u2014 ' + s;
    }

    document.querySelectorAll('.pdp__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.pdp__qty-input');
        var val = parseInt(input.value) || 1;
        if (btn.dataset.action === 'increase') input.value = val + 1;
        else if (btn.dataset.action === 'decrease' && val > 1) input.value = val - 1;
        updateAtcPrice();
      });
    });

    /* Purchase option toggle : simplified (one-time vs 3-month prepaid) */
    var purchaseOpts = document.querySelector('[data-purchase-opts]');
    if (purchaseOpts) {
      var rawPrice = parseInt(purchaseOpts.getAttribute('data-raw-price'), 10);
      var subPlanId = purchaseOpts.getAttribute('data-sub-plan-id') || '';
      var subTotal = parseInt(purchaseOpts.getAttribute('data-sub-total'), 10) || 0;
      var sellingPlanInput = document.querySelector('[data-selling-plan-input]');

      function fmtMoney(cents) {
        return 'CHF ' + Math.round(cents / 100) + '.–';
      }

      /* Init is applied after selectOpt + opts are defined (see below) */

      var opts = purchaseOpts.querySelectorAll('.pdp__opt');
      function selectOpt(opt) {
          opts.forEach(function(o) { o.classList.remove('pdp__opt--active'); });
          opt.classList.add('pdp__opt--active');
          opt.querySelector('input').checked = true;

          /* Data-driven: read plan + price from the selected card (supports N options) */
          var planId = opt.getAttribute('data-plan-id') || '';
          var unitCents = parseInt(opt.getAttribute('data-unit-cents'), 10);
          if (isNaN(unitCents)) { unitCents = rawPrice; }
          var priceLabel = opt.getAttribute('data-price-label');
          var unitLabel = opt.getAttribute('data-unit-label');
          var isSubscribe = (opt.getAttribute('data-img') === 'sub');
          var _nudge = document.querySelector('[data-monthly-nudge]');
          if (_nudge) { _nudge.style.display = (opt.getAttribute('data-opt') === 'onetime') ? 'block' : 'none'; }
          if (sellingPlanInput) {
            sellingPlanInput.value = planId;
            sellingPlanInput._nuhoValue = planId;
          }

          /* Update unit price on button and recalc */
          var atcBtn = document.querySelector('[data-atc-btn]');
          if (atcBtn) {
            atcBtn.setAttribute('data-unit-price', unitCents);
            atcBtn.setAttribute('data-selling-plan-id', planId);
            updateAtcPrice();
          }

          /* Update top price display */
          var priceDisplay = document.querySelector('[data-price-display]');
          if (priceDisplay && priceLabel) { priceDisplay.textContent = priceLabel; }
          var unitDisplay = document.querySelector('[data-unit-display]');
          if (unitDisplay && unitLabel) { unitDisplay.innerHTML = unitLabel; }
          /* Sync mini buy button with selling plan id */
          var miniBtn = document.querySelector('[data-atc-btn-mini]');
          if (miniBtn) { miniBtn.setAttribute('data-selling-plan-id', planId); }
          /* Sync mobile sticky bar price (-10% strike for ad traffic) */
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice && priceLabel) {
            var _adOn = false; try { _adOn = (localStorage.getItem('nuho_ad') === '1'); } catch (e) {}
            var _isSubCard = (opt.getAttribute('data-opt') !== 'onetime');
            if (_adOn && _isSubCard && !isNaN(unitCents)) {
              var _orig = unitCents / 100;
              var _pre = /d[eè]s/i.test(priceLabel) ? 'dès ' : '';
              var _suf = priceLabel.replace(/d[eè]s\s*/i, '').replace(/CHF\s*/i, '').replace(/\d+[.,]?\s*–?/, '').trim();
              stickyPrice.innerHTML = _pre + '<s style="color:#b8b8b8;font-weight:600;font-size:.85em">CHF ' + _orig.toFixed(0) + '.–</s> <span style="color:#157a3f">CHF ' + (_orig * 0.9).toFixed(2) + '</span>' + (_suf ? _suf : '');
            } else {
              stickyPrice.textContent = priceLabel;
            }
          }
          /* Swap main product image: subscription = 3-pack with spoon, one-time = single pouch */
          var mainImg = document.getElementById('main-product-image');
          if (mainImg) {
            var newSrc = isSubscribe ? mainImg.getAttribute('data-sub-img') : mainImg.getAttribute('data-onetime-img');
            var imgWrap = mainImg.closest('.pdp__main-img');
            if (imgWrap) {
              imgWrap.classList.toggle('pdp__main-img--sub', !!isSubscribe);
            }
            if (newSrc && mainImg.src !== newSrc) {
              mainImg.style.opacity = '0';
              setTimeout(function() {
                mainImg.src = newSrc;
                mainImg.style.opacity = '1';
              }, 150);
            }
          }
      }
      window.__nuhoSelectOpt = selectOpt;
      opts.forEach(function(opt) { opt.addEventListener('click', function() { selectOpt(opt); }); });
      /* Nudge: "Switch to monthly" button selects the monthly card (capture phase to beat the label's own click) */
      document.addEventListener('click', function(e){
        var gb = e.target.closest('[data-goto-monthly]');
        if(!gb) return;
        e.preventDefault(); e.stopPropagation();
        var m = purchaseOpts.querySelector('.pdp__opt[data-opt="monthly"]');
        if(m){ selectOpt(m); try{ m.scrollIntoView({behavior:'smooth',block:'center'}); }catch(_){} }
      }, true);
      /* Init: apply the default-active card (data-driven) */
      var _activeCardInit = purchaseOpts.querySelector('.pdp__opt--active');
      if (_activeCardInit) { selectOpt(_activeCardInit); }

      /* NUHO-JS-OFFER-PRESELECT v3 : ad/Meta traffic -> abo mensuel (message match) */
      try {
        var _pq = new URLSearchParams(window.location.search);
        var _tgt = null;
        if (_pq.get('offer') === 'onetime') { _tgt = 'onetime'; }
        else if (_pq.get('offer') === 'subscribe') { _tgt = 'subscribe'; }
        else if (_pq.get('offer') === 'monthly' || _pq.get('utm_source') === 'meta') { _tgt = 'monthly'; }
        if (_tgt) {
          var _tOpt = purchaseOpts.querySelector('.pdp__opt[data-opt="' + _tgt + '"]');
          if (_tOpt && !_tOpt.classList.contains('pdp__opt--active')) { selectOpt(_tOpt); }
        }
      } catch (e) {}
    }

    /* On page load: if subscribe is default-selected, swap to subscription image */
    (function() {
      var mainImg = document.getElementById('main-product-image');
      var activeOpt = document.querySelector('.pdp__opt--active input[value="subscribe"]');
      if (mainImg && activeOpt) {
        var subSrc = mainImg.getAttribute('data-sub-img');
        if (subSrc) mainImg.src = subSrc;
      }
    })();

    /* Mini buy button : delegates to main hero buy button */
    (function(){
      var mini = document.getElementById('nuho-buy-btn-mini');
      var main = document.getElementById('nuho-buy-btn-hero');
      if (!mini || !main) return;
      mini.addEventListener('click', function(e) {
        e.preventDefault();
        main.click();
      });
    })();

    /* In-option buy buttons : delegate to the main hero buy button.
       Stop propagation so clicking the button doesn't toggle the radio label. */
    (function(){
      document.querySelectorAll('[data-opt-buy]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('.pdp__opt');
          var planId = card ? (card.getAttribute('data-plan-id') || '') : '';
          var qtyInput = document.querySelector('[data-pdp-qty]');
          var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
          var _vidEl = document.querySelector('[data-variant-id]');
          var _vid = _vidEl ? parseInt(_vidEl.getAttribute('data-variant-id'), 10) : null;
          if (!_vid) { return; }
          var item = { id: _vid, quantity: qty };
          if (planId) { item.selling_plan = parseInt(planId, 10); }
          btn.style.opacity = '0.55'; btn.style.pointerEvents = 'none';
          fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[item] }) })
            .then(function(r){ return r.json(); })
            .then(function(){ btn.style.opacity=''; btn.style.pointerEvents=''; if (typeof openDrawer === 'function') { openDrawer(); } else { window.location.href = '/cart'; } })
            .catch(function(){ btn.style.opacity=''; btn.style.pointerEvents=''; window.location.href = '/cart'; });
        });
      });
    })();

    /* Add-to-cart handled by inline script on the button : see product-v2.liquid */

    /* ── Apply discount cookie when ?apply_discount=CODE is present ── */
    (function() {
      var params = new URLSearchParams(window.location.search);
      var code = params.get('apply_discount');
      if (!code) return;

      /* 1. Clear any existing discount cookie immediately (sync) */
      document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

      /* 2. Disable buy buttons until new discount cookie is set */
      function getBuyBtns() {
        return document.querySelectorAll('#nuho-buy-btn-hero, #nuho-buy-btn-mini, [data-product-form-submit], button[name="add"]');
      }
      function setBtnsState(disabled, label) {
        getBuyBtns().forEach(function(b) {
          b.disabled = disabled;
          if (label !== undefined && b.tagName === 'BUTTON') {
            if (disabled) b.dataset.originalLabel = b.textContent;
            b.textContent = disabled ? label : (b.dataset.originalLabel || b.textContent);
          }
        });
      }
      /* Disable now (and again after DOMContentLoaded in case buttons aren't mounted yet) */
      var disable = function() { setBtnsState(true, 'Application de l\'offre…'); };
      disable();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', disable);
      }

      /* 3. Apply new discount via Shopify endpoint */
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      }).finally(function() {
        /* Re-enable buy buttons once cookie is set */
        setBtnsState(false);
      });
    })();

    /* ── Hidden-offer PDP: override displayed price when ?p= query param is present ── */
    (function() {
      var banner = document.getElementById('pdp-offer-banner');
      if (!banner) return;
      var params = new URLSearchParams(window.location.search);
      var p = parseInt(params.get('p'), 10);
      if (!p || p <= 0) return;

      /* Update the main price element */
      var priceEl = document.querySelector('[data-price-display]') || document.querySelector('.pdp__price');
      if (priceEl) {
        var original = priceEl.textContent.trim();
        priceEl.innerHTML = 'CHF ' + p + '.–' +
          '<span class="pdp__price--original-strike">' + original + '</span>';
      }

      /* Update the mini-buy button if present */
      var miniBtn = document.getElementById('nuho-buy-btn-mini');
      if (miniBtn) miniBtn.textContent = 'Acheter : CHF ' + p;

      /* Update the main hero buy button label */
      var mainBtn = document.getElementById('nuho-buy-btn-hero');
      if (mainBtn) mainBtn.textContent = 'Acheter : CHF ' + p + '.–';

      /* Show banner */
      var msg = document.getElementById('pdp-offer-price-text');
      if (msg) msg.textContent = 'Votre prix final : CHF ' + p + '.– (appliqué au checkout)';
      banner.style.display = 'flex';
    })();

    /* Ingredients show-more toggle */
    (function() {
      var btn = document.querySelector('[data-nt-toggle]');
      var extra = document.querySelector('[data-nt-extra]');
      if (!btn || !extra) return;
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) extra.setAttribute('hidden', '');
        else extra.removeAttribute('hidden');
      });
    })();

    /* Thumbnail gallery */
    document.querySelectorAll('.pdp__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var mainImg = document.getElementById('main-product-image');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = thumb.dataset.imageUrl;
            mainImg.style.opacity = '1';
          }, 150);
        }
        document.querySelectorAll('.pdp__thumb').forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
        thumb.classList.add('pdp__thumb--active');
      });
    });

    /* Mobile sticky bar : show when form scrolls out of view */
    var form = document.getElementById('pdp-form');
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (form && sticky) {
      var obs = new IntersectionObserver(function(entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(form);

      /* Sticky bar add-to-cart */
      var stickyBtn = sticky.querySelector('[data-pdp-sticky-add]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
          var formData = new FormData(form);
          var data = {};
          formData.forEach(function(v, k) { data[k] = v; });
          var item = { id: parseInt(data.id, 10), quantity: parseInt(data.quantity, 10) || 1 };
          if (data.selling_plan && data.selling_plan !== '') {
            item.selling_plan = parseInt(data.selling_plan, 10);
          }
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            if (window.openCartDrawer) window.openCartDrawer();
          });
        });
      }
    }

    /* ── Scroll to reviews if #nuho-reviews or #jdgm-widget hash present ── */
    if (window.location.hash === '#nuho-reviews' || window.location.hash === '#jdgm-widget') {
      setTimeout(function() {
        var widget = document.getElementById('nuho-reviews');
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }

    /* ── Auto-open review form if #write-review hash present ── */
    if (window.location.hash === '#write-review') {
      var attempts = 0;
      var tryOpen = function() {
        var widget = document.getElementById('nuho-reviews');
        var formWrap = document.getElementById('nuho-rev-form-wrap');
        var toggleBtn = document.getElementById('nuho-rev-toggle');
        if (formWrap) {
          if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          formWrap.style.display = 'block';
          if (toggleBtn) toggleBtn.textContent = '{{ "reviews.cancel" | t | default: "Cancel" }}';
        } else if (attempts < 20) {
          attempts++;
          setTimeout(tryOpen, 300);
        }
      };
      setTimeout(tryOpen, 500);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Quantity buttons
  document.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.cart-item__qty-input');
      const currentValue = parseInt(input.value) || 1;

      if (btn.dataset.action === 'increase') {
        input.value = currentValue + 1;
      } else if (btn.dataset.action === 'decrease') {
        input.value = Math.max(0, currentValue - 1);
      }

      // Auto-submit form after quantity change
      document.getElementById('cart-form').submit();
    });
  });

  // Also submit on input change
  document.querySelectorAll('.cart-item__qty-input').forEach(input => {
    input.addEventListener('change', () => {
      document.getElementById('cart-form').submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  (function() {
    var formWrap = document.querySelector('[data-add-form]');
    var addBtn = document.querySelector('.addr__add-btn');
    document.querySelectorAll('[data-toggle-add]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var isHidden = formWrap.style.display === 'none';
        formWrap.style.display = isHidden ? 'block' : 'none';
        if (addBtn) addBtn.style.display = isHidden ? 'none' : 'inline-flex';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  (function() {
    /* Toggle password visibility */
    document.querySelectorAll('[data-toggle-pw]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('input');
        input.type = input.type === 'password' ? 'text' : 'password';
      });
    });

    /* Toggle recover form */
    var loginForm = document.querySelector('.cust form[action*="login"]') || document.querySelector('.cust form:first-of-type');
    var recoverForm = document.querySelector('[data-recover-form]');
    document.querySelectorAll('[data-toggle-recover]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (recoverForm.style.display === 'none') {
          recoverForm.style.display = 'block';
          if (loginForm) loginForm.style.display = 'none';
        } else {
          recoverForm.style.display = 'none';
          if (loginForm) loginForm.style.display = 'block';
        }
      });
    });

    /* Auto-show recover if URL has #recover */
    if (window.location.hash === '#recover' && recoverForm) {
      recoverForm.style.display = 'block';
      if (loginForm) loginForm.style.display = 'none';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"]) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-toggle-pw]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('input');
        input.type = input.type === 'password' ? 'text' : 'password';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["david-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-david]');
    if (!root) return;

    /* Reveal-on-scroll : opt-in hidden state (so JS failures don't leave page blank) */
    var reveals = root.querySelectorAll('[data-reveal]');
    root.classList.add('david--reveal-ready');

    function revealAll() {
      reveals.forEach(function(el) { el.classList.add('is-in'); });
    }

    /* Safety net: force-reveal everything after 2s no matter what (covers slow/blocked observers) */
    var safety = setTimeout(revealAll, 2000);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      reveals.forEach(function(el) { io.observe(el); });
      /* First section should always be visible immediately, regardless of intersection timing */
      if (reveals.length) reveals[0].classList.add('is-in');
    } else {
      revealAll();
      clearTimeout(safety);
    }

    /* Scroll progress */
    var bar = root.querySelector('.david__progress > i');
    if (bar) {
      var rect = root.getBoundingClientRect();
      var update = function() {
        var top = root.offsetTop;
        var h = root.offsetHeight - window.innerHeight;
        var y = window.scrollY - top;
        var p = Math.max(0, Math.min(1, y / (h || 1)));
        bar.style.width = (p * 100).toFixed(1) + '%';
      };
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    /* Hero subtle parallax-tilt on pointer */
    var tilt = root.querySelector('[data-tilt]');
    if (tilt && window.matchMedia('(pointer: fine)').matches) {
      var max = 6;
      tilt.addEventListener('pointermove', function(e) {
        var r = tilt.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        tilt.style.transform = 'perspective(1000px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-4px)';
      });
      tilt.addEventListener('pointerleave', function() {
        tilt.style.transform = '';
      });
    }

    /* Lite-YouTube embed */
    var ytWrap = root.querySelector('[data-yt]');
    if (ytWrap) {
      ytWrap.addEventListener('click', function() {
        if (ytWrap.classList.contains('is-playing')) return;
        var id = ytWrap.getAttribute('data-yt');
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        iframe.title = 'David Giovenco : interview';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        ytWrap.appendChild(iframe);
        ytWrap.classList.add('is-playing');
      });
    }

    /* Stat count-up */
    var nums = root.querySelectorAll('.david__stat-num');
    var animateNum = function(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      var suffix = el.getAttribute('data-suffix') || '';
      if (isNaN(target)) return;
      var dur = 1100;
      var start = performance.now();
      var step = function(t) {
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) { animateNum(e.target); io2.unobserve(e.target); }
        });
      }, { threshold: 0.4 });
      nums.forEach(function(n) { io2.observe(n); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const triggers = document.querySelectorAll('[data-faq-trigger]');

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const item = this.closest('.faq__item');
        const isOpen = item.classList.contains('is-open');

        // Close all items first (single accordion behavior)
        document.querySelectorAll('.faq__item').forEach(function(i) {
          i.classList.remove('is-open');
        });

        // Open clicked item if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function() {
  var trigger = document.querySelector('[data-footer-nl-trigger]');
  if (!trigger) return;
  trigger.addEventListener('click', function() {
    var popup = document.querySelector('[data-nl-popup]');
    var overlay = document.querySelector('[data-nl-overlay]');
    if (popup && overlay) {
      popup.classList.add('is-visible');
      overlay.classList.add('is-visible');
      document.documentElement.classList.add('scroll-lock');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* ── Language dropdown toggle ── */
    var langToggle = document.querySelector('[data-lang-toggle]');
    var langDropdown = document.querySelector('[data-lang-dropdown]');
    if (langToggle && langDropdown) {
      langToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = langDropdown.style.display !== 'none';
        langDropdown.style.display = isOpen ? 'none' : '';
        langToggle.querySelector('.lang-chevron').style.transform = isOpen ? '' : 'rotate(180deg)';
      });
      document.addEventListener('click', function(e) {
        if (!langToggle.contains(e.target) && !langDropdown.contains(e.target)) {
          langDropdown.style.display = 'none';
          langToggle.querySelector('.lang-chevron').style.transform = '';
        }
      });
    }

    /* ── Language switching via URL navigation ── */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-switch-locale]');
      if (!btn) return;
      var code = btn.getAttribute('data-switch-locale');
      localStorage.setItem('nuho-locale-detected', code);
      var path = window.location.pathname;
      /* Strip existing locale prefix (FR is served at root, so EN/DE/IT are prefixed) */
      var cleaned = path.replace(/^\/(en|fr|de|it)(\/|$)/, '/');
      var newPath = (code === 'fr') ? cleaned : ('/' + code + cleaned);
      window.location.href = newPath + window.location.search;
    });

    /* ── Mobile menu toggle ── */
    var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        var isOpen = mobileMenu.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.documentElement.classList.toggle('scroll-lock', isOpen);
      });
    }

    /* ── Header scroll state ── */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function() {
        header.classList.toggle('is-scrolled', window.scrollY > 20);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kol-signup"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('kol-form');
    var btn = document.getElementById('kol-submit-btn');
    var msg = document.getElementById('kol-msg');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var firstName = document.getElementById('kol-firstname').value.trim();
      var lastName = document.getElementById('kol-lastname').value.trim();
      var email = document.getElementById('kol-email').value.trim();
      var langSelect = document.getElementById('kol-lang');
      var lang = (langSelect && langSelect.value) || (document.documentElement.lang || 'fr').split('-')[0];
      if (!firstName || !lastName || !email) {
        msg.textContent = 'Veuillez remplir prénom, nom et email.';
        msg.style.color = '#dc2626';
        msg.style.display = '';
        return;
      }

      btn.disabled = true;
      btn.querySelector('.kol-signup__submit-text').style.display = 'none';
      btn.querySelector('.kol-signup__spinner').style.display = '';
      msg.style.display = 'none';

      fetch('https://api2.nuho.ch/api/kol-apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          first_name: firstName,
          last_name: lastName,
          email: email,
          instagram: document.getElementById('kol-instagram').value.trim(),
          tiktok: document.getElementById('kol-tiktok').value.trim(),
          audience_size: document.getElementById('kol-audience').value,
          motivation: document.getElementById('kol-motivation').value.trim(),
          lang: lang
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.error) {
          msg.textContent = data.error;
          msg.style.color = '#dc2626';
          msg.style.display = '';
          btn.disabled = false;
          btn.querySelector('.kol-signup__submit-text').style.display = '';
          btn.querySelector('.kol-signup__spinner').style.display = 'none';
          return;
        }

        /* Show success : code/link revealed at admin approval, not here */
        form.style.display = 'none';
        document.querySelector('.kol-signup__form-title').style.display = 'none';
        document.querySelector('.kol-signup__form-desc').style.display = 'none';
        document.getElementById('kol-success').style.display = '';
      })
      .catch(function(err) {
        msg.textContent = form.getAttribute('data-error-msg') || 'An error occurred. Please try again.';
        msg.style.color = '#dc2626';
        msg.style.display = '';
        btn.disabled = false;
        btn.querySelector('.kol-signup__submit-text').style.display = '';
        btn.querySelector('.kol-signup__spinner').style.display = 'none';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var form = document.getElementById('nl-banner-form');
  var submitBtn = document.querySelector('[data-nl-banner-submit]');
  var errorEl = document.querySelector('[data-nl-banner-error]');
  var successEl = document.querySelector('[data-nl-banner-success]');

  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var email = form.querySelector('[data-nl-banner-email]').value.trim();
    if (!email) return;

    errorEl.style.display = 'none';
    submitBtn.disabled = true;
    submitBtn.querySelector('.nl-banner__submit-text').style.display = 'none';
    submitBtn.querySelector('.nl-banner__submit-loading').style.display = '';

    fetch('https://api2.nuho.ch/api/newsletter-subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        redirection_url: window.location.origin
      })
    })
    .then(function(r) {
      if (r.ok) {
        form.style.display = 'none';
        successEl.style.display = '';
        localStorage.setItem('nuho-nl-dismissed', 'subscribed');
      } else {
        return r.json().then(function(d) { throw new Error(d.error || 'Please try again.'); });
      }
    })
    .catch(function(err) {
      errorEl.textContent = err.message || 'Something went wrong.';
      errorEl.style.display = '';
      submitBtn.disabled = false;
      submitBtn.querySelector('.nl-banner__submit-text').style.display = '';
      submitBtn.querySelector('.nl-banner__submit-loading').style.display = 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offres-page"]) return;
  try {
    
  (function() {
    const API_URL = 'https://api2.nuho.ch/api/check-therapist';

    /* Tab switching */
    const tabs = document.querySelectorAll('.offres__tab');
    const panels = document.querySelectorAll('.offres__panel');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const target = tab.dataset.tab;
        tabs.forEach(function(t) {
          t.classList.toggle('offres__tab--active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          p.classList.toggle('offres__panel--active', p.id === 'panel-' + target);
        });
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({ top: window.scrollY, behavior: 'smooth' });
        }
      });
    });

    /* Therapist email check */
    const emailInput = document.getElementById('check-email');
    const checkBtn = document.getElementById('check-btn');
    const status = document.getElementById('check-status');
    const offersBox = document.getElementById('therapeute-offers');
    const greeting = document.getElementById('therapeute-greeting');
    const checkForm = document.getElementById('check-form');
    const notPartner = document.getElementById('not-partner');
    const notPartnerMsg = document.getElementById('not-partner-msg');
    const logoutBtn = document.getElementById('logout-btn');
    const retryBtn = document.getElementById('retry-btn');

    function showState(state, payload) {
      checkForm.style.display = state === 'form' ? 'block' : 'none';
      offersBox.toggleAttribute('hidden', state !== 'success');
      offersBox.dataset.visible = state === 'success' ? 'true' : 'false';
      notPartner.toggleAttribute('hidden', state !== 'fail');
      notPartner.dataset.visible = state === 'fail' ? 'true' : 'false';
      if (state === 'success' && payload) {
        greeting.textContent = 'Bonjour ' + (payload.name || '') + ', vos tarifs thérapeute sont débloqués.';
      }
      if (state === 'fail' && payload) {
        notPartnerMsg.textContent = payload.message || "Cette adresse n'est pas dans notre base partenaire.";
      }
    }

    /* Restore previous verified email */
    const prevEmail = localStorage.getItem('therapeute-email');
    if (prevEmail) {
      emailInput.value = prevEmail;
      check(true);
    }

    async function check(isAuto) {
      const email = (emailInput.value || '').trim().toLowerCase();
      if (!email) { status.textContent = 'Saisissez votre email.'; return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { status.textContent = 'Email invalide.'; return; }

      checkBtn.disabled = true;
      const originalText = checkBtn.textContent;
      checkBtn.textContent = 'Vérification…';
      status.textContent = '';

      try {
        const r = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email }),
        });
        const data = await r.json();
        if (data.is_therapist) {
          localStorage.setItem('therapeute-email', email);
          showState('success', data);
        } else {
          if (isAuto) {
            /* If auto-restore failed, just show the form again */
            localStorage.removeItem('therapeute-email');
            showState('form');
          } else {
            showState('fail', data);
          }
        }
      } catch (e) {
        status.textContent = 'Erreur de vérification. Réessayez.';
      } finally {
        checkBtn.disabled = false;
        checkBtn.textContent = originalText;
      }
    }

    checkBtn.addEventListener('click', function() { check(false); });
    emailInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); check(false); }
    });
    if (logoutBtn) logoutBtn.addEventListener('click', function() {
      localStorage.removeItem('therapeute-email');
      emailInput.value = '';
      showState('form');
      emailInput.focus();
    });
    if (retryBtn) retryBtn.addEventListener('click', function() {
      emailInput.value = '';
      showState('form');
      emailInput.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partenaires-page"]) return;
  try {
    
(function() {
  var programInput = document.getElementById('partner-program-input');
  if (!programInput) return;

  var form = document.getElementById('partners-form');
  var btn = document.getElementById('partners-submit-btn');
  var msg = document.getElementById('partners-form-msg');
  var diplomaField = document.getElementById('partner-diploma-field');
  var diplomaFileField = document.getElementById('partner-diploma-file-field');
  var companyField = document.getElementById('partner-company-field');
  var fileInput = document.getElementById('partner-diploma-file');
  var fileDisplay = fileInput.parentElement.querySelector('.partners__file-display');
  var fileText = fileDisplay.querySelector('.partners__file-text');
  var toggleBtns = document.querySelectorAll('.partners__program-btn');
  var cardBtns = document.querySelectorAll('[data-partner-select]');
  var tierField = document.getElementById('partner-tier-field');
  var tierInput = document.getElementById('partner-tier-input');
  var tierCards = document.querySelectorAll('.partners__tier-card');
  var currentProgram = 'therapist';
  var currentTier = 'therapeute20';

  /* File name display */
  fileInput.addEventListener('change', function() {
    if (fileInput.files && fileInput.files[0]) {
      fileText.textContent = fileInput.files[0].name;
      fileDisplay.classList.add('has-file');
    } else {
      fileText.textContent = 'PDF, JPG or PNG (max 5 MB)';
      fileDisplay.classList.remove('has-file');
    }
  });

  /* Tier selection */
  function setTier(tierValue) {
    currentTier = tierValue;
    tierCards.forEach(function(c) {
      c.classList.toggle('partners__tier-card--active', c.getAttribute('data-tier') === tierValue);
    });
    if (tierValue === 'therapeute20') {
      tierInput.value = 'Thérapeute 20%';
      programInput.value = 'Thérapeute 20%';
    } else {
      tierInput.value = 'Thérapeute Pro 30%';
      programInput.value = 'Thérapeute Pro 30%';
    }
  }

  tierCards.forEach(function(c) {
    c.addEventListener('click', function() {
      setTier(c.getAttribute('data-tier'));
    });
  });

  function setProgram(type) {
    currentProgram = type;
    toggleBtns.forEach(function(b) {
      b.classList.toggle('partners__program-btn--active', b.getAttribute('data-program') === type);
    });
    if (type === 'therapist') {
      tierField.style.display = '';
      setTier(currentTier);
      diplomaField.style.display = '';
      diplomaFileField.style.display = '';
      companyField.style.display = 'none';
    } else {
      programInput.value = 'Distributeur';
      tierField.style.display = 'none';
      diplomaField.style.display = '';
      diplomaFileField.style.display = '';
      companyField.style.display = '';
    }
  }

  toggleBtns.forEach(function(b) {
    b.addEventListener('click', function() { setProgram(b.getAttribute('data-program')); });
  });
  cardBtns.forEach(function(b) {
    b.addEventListener('click', function() { setProgram(b.getAttribute('data-partner-select')); });
  });

  /* Read file as base64 */
  function readFileAsBase64(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() { resolve(reader.result.split(',')[1]); };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  /* Submit via Brevo SMTP */
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var firstName = document.getElementById('partner-firstname').value.trim();
    var lastName = document.getElementById('partner-lastname').value.trim();
    var email = document.getElementById('partner-email').value.trim();
    var phone = document.getElementById('partner-phone').value.trim();
    var diploma = document.getElementById('partner-diploma').value.trim();
    var company = document.getElementById('partner-company').value.trim();
    var message = document.getElementById('partner-message').value.trim();
    var program = programInput.value;
    var fullName = firstName + ' ' + lastName;

    if (!firstName || !lastName || !email) return;

    btn.disabled = true;
    btn.querySelector('.partners__submit-text').style.display = 'none';
    btn.querySelector('.partners__spinner').style.display = 'block';
    msg.style.display = 'none';

    var file = (fileInput.files && fileInput.files[0]) ? fileInput.files[0] : null;
    var filePromise = file ? readFileAsBase64(file) : Promise.resolve(null);

    filePromise.then(function(base64Content) {
      var payload = {
        type: 'partner',
        program: program,
        tier: currentProgram === 'therapist' ? tierInput.value : '',
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone,
        diploma: diploma,
        company: currentProgram === 'therapist' ? '' : company,
        message: message
      };
      if (base64Content && file) payload.file = { content: base64Content, name: file.name };

      return fetch('https://api2.nuho.ch/api/application', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(r) {
      if (r.ok) {
        form.reset();
        fileText.textContent = 'PDF, JPG or PNG (max 5 MB)';
        fileDisplay.classList.remove('has-file');
        currentTier = 'therapeute20';
        setProgram('therapist');
        msg.textContent = 'Application received! We will review it and get back to you within 48 hours.';
        msg.style.color = '#16a34a';
        msg.style.display = '';
      } else {
        return r.json().then(function(d) { throw new Error(d.error || 'Error'); });
      }
    })
    .catch(function(err) {
      msg.textContent = err.message || 'Something went wrong. Please try again.';
      msg.style.color = '#ef4444';
      msg.style.display = '';
    })
    .finally(function() {
      btn.disabled = false;
      btn.querySelector('.partners__submit-text').style.display = '';
      btn.querySelector('.partners__spinner').style.display = 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-v2"]) return;
  try {
    
  (function() {
    /* Quantity +/- with price update */
    function updateAtcPrice() {
      var atcBtn = document.querySelector('[data-atc-btn]');
      if (!atcBtn) return;
      var unitPrice = parseInt(atcBtn.getAttribute('data-unit-price'), 10);
      var qtyInput = document.querySelector('[data-pdp-qty]');
      var qty = parseInt(qtyInput.value) || 1;
      var total = unitPrice * qty;
      var rounded = Math.round(total / 100);
      var s = 'CHF ' + rounded + '.–';
      var label = atcBtn.textContent.split('\u2014')[0].trim();
      atcBtn.textContent = label + ' \u2014 ' + s;
    }

    document.querySelectorAll('.pdp__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.pdp__qty-input');
        var val = parseInt(input.value) || 1;
        if (btn.dataset.action === 'increase') input.value = val + 1;
        else if (btn.dataset.action === 'decrease' && val > 1) input.value = val - 1;
        updateAtcPrice();
      });
    });

    /* Purchase option toggle : simplified (one-time vs 3-month prepaid) */
    var purchaseOpts = document.querySelector('[data-purchase-opts]');
    if (purchaseOpts) {
      var rawPrice = parseInt(purchaseOpts.getAttribute('data-raw-price'), 10);
      var subPlanId = purchaseOpts.getAttribute('data-sub-plan-id') || '';
      var subTotal = parseInt(purchaseOpts.getAttribute('data-sub-total'), 10) || 0;
      var sellingPlanInput = document.querySelector('[data-selling-plan-input]');

      function fmtMoney(cents) {
        return 'CHF ' + Math.round(cents / 100) + '.–';
      }

      /* Init is applied after selectOpt + opts are defined (see below) */

      var opts = purchaseOpts.querySelectorAll('.pdp__opt');
      function selectOpt(opt) {
          opts.forEach(function(o) { o.classList.remove('pdp__opt--active'); });
          opt.classList.add('pdp__opt--active');
          opt.querySelector('input').checked = true;

          /* Data-driven: read plan + price from the selected card (supports N options) */
          var planId = opt.getAttribute('data-plan-id') || '';
          var unitCents = parseInt(opt.getAttribute('data-unit-cents'), 10);
          if (isNaN(unitCents)) { unitCents = rawPrice; }
          var priceLabel = opt.getAttribute('data-price-label');
          var unitLabel = opt.getAttribute('data-unit-label');
          var isSubscribe = (opt.getAttribute('data-img') === 'sub');
          var _nudge = document.querySelector('[data-monthly-nudge]');
          if (_nudge) { _nudge.style.display = (opt.getAttribute('data-opt') === 'onetime') ? 'block' : 'none'; }
          if (sellingPlanInput) {
            sellingPlanInput.value = planId;
            sellingPlanInput._nuhoValue = planId;
          }

          /* Update unit price on button and recalc */
          var atcBtn = document.querySelector('[data-atc-btn]');
          if (atcBtn) {
            atcBtn.setAttribute('data-unit-price', unitCents);
            atcBtn.setAttribute('data-selling-plan-id', planId);
            updateAtcPrice();
          }

          /* Update top price display */
          var priceDisplay = document.querySelector('[data-price-display]');
          if (priceDisplay && priceLabel) { priceDisplay.textContent = priceLabel; }
          var unitDisplay = document.querySelector('[data-unit-display]');
          if (unitDisplay && unitLabel) { unitDisplay.innerHTML = unitLabel; }
          /* Sync mini buy button with selling plan id */
          var miniBtn = document.querySelector('[data-atc-btn-mini]');
          if (miniBtn) { miniBtn.setAttribute('data-selling-plan-id', planId); }
          /* Sync mobile sticky bar price (-10% strike for ad traffic) */
          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice && priceLabel) {
            stickyPrice.textContent = priceLabel;
          }
          /* Swap main product image: subscription = 3-pack with spoon, one-time = single pouch */
          var mainImg = document.getElementById('main-product-image');
          if (mainImg) {
            var newSrc = isSubscribe ? mainImg.getAttribute('data-sub-img') : mainImg.getAttribute('data-onetime-img');
            var imgWrap = mainImg.closest('.pdp__main-img');
            if (imgWrap) {
              imgWrap.classList.toggle('pdp__main-img--sub', !!isSubscribe);
            }
            if (newSrc && mainImg.src !== newSrc) {
              mainImg.style.opacity = '0';
              setTimeout(function() {
                mainImg.src = newSrc;
                mainImg.style.opacity = '1';
              }, 150);
            }
          }
      }
      window.__nuhoSelectOpt = selectOpt;
      opts.forEach(function(opt) { opt.addEventListener('click', function() { selectOpt(opt); }); });
      /* Nudge: "Switch to monthly" button selects the monthly card (capture phase to beat the label's own click) */
      document.addEventListener('click', function(e){
        var gb = e.target.closest('[data-goto-monthly]');
        if(!gb) return;
        e.preventDefault(); e.stopPropagation();
        var m = purchaseOpts.querySelector('.pdp__opt[data-opt="monthly"]');
        if(m){ selectOpt(m); try{ m.scrollIntoView({behavior:'smooth',block:'center'}); }catch(_){} }
      }, true);
      /* Init: apply the default-active card (data-driven) */
      var _activeCardInit = purchaseOpts.querySelector('.pdp__opt--active');
      if (_activeCardInit) { selectOpt(_activeCardInit); }

      /* NUHO-JS-OFFER-PRESELECT v3 : ad/Meta traffic -> abo mensuel (message match) */
      try {
        var _pq = new URLSearchParams(window.location.search);
        var _tgt = null;
        if (_pq.get('offer') === 'onetime') { _tgt = 'onetime'; }
        else if (_pq.get('offer') === 'subscribe') { _tgt = 'subscribe'; }
        else if (_pq.get('offer') === 'monthly' || _pq.get('utm_source') === 'meta') { _tgt = 'monthly'; }
        if (_tgt) {
          var _tOpt = purchaseOpts.querySelector('.pdp__opt[data-opt="' + _tgt + '"]');
          if (_tOpt && !_tOpt.classList.contains('pdp__opt--active')) { selectOpt(_tOpt); }
        }
      } catch (e) {}
    }

    /* On page load: if subscribe is default-selected, swap to subscription image */
    (function() {
      var mainImg = document.getElementById('main-product-image');
      var activeOpt = document.querySelector('.pdp__opt--active input[value="subscribe"]');
      if (mainImg && activeOpt) {
        var subSrc = mainImg.getAttribute('data-sub-img');
        if (subSrc) mainImg.src = subSrc;
      }
    })();

    /* Mini buy button : delegates to main hero buy button */
    (function(){
      var mini = document.getElementById('nuho-buy-btn-mini');
      var main = document.getElementById('nuho-buy-btn-hero');
      if (!mini || !main) return;
      mini.addEventListener('click', function(e) {
        e.preventDefault();
        main.click();
      });
    })();

    /* In-option buy buttons : delegate to the main hero buy button.
       Stop propagation so clicking the button doesn't toggle the radio label. */
    (function(){
      document.querySelectorAll('[data-opt-buy]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('.pdp__opt');
          var planId = card ? (card.getAttribute('data-plan-id') || '') : '';
          var qtyInput = document.querySelector('[data-pdp-qty]');
          var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
          var _vidEl = document.querySelector('[data-variant-id]');
          var _vid = _vidEl ? parseInt(_vidEl.getAttribute('data-variant-id'), 10) : null;
          if (!_vid) { return; }
          var item = { id: _vid, quantity: qty };
          if (planId) { item.selling_plan = parseInt(planId, 10); }
          btn.style.opacity = '0.55'; btn.style.pointerEvents = 'none';
          fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[item] }) })
            .then(function(r){ return r.json(); })
            .then(function(){ btn.style.opacity=''; btn.style.pointerEvents=''; if (typeof openDrawer === 'function') { openDrawer(); } else { window.location.href = '/cart'; } })
            .catch(function(){ btn.style.opacity=''; btn.style.pointerEvents=''; window.location.href = '/cart'; });
        });
      });
    })();

    /* Add-to-cart handled by inline script on the button : see product-v2.liquid */

    /* ── Apply discount cookie when ?apply_discount=CODE is present ── */
    (function() {
      var params = new URLSearchParams(window.location.search);
      var code = params.get('apply_discount');
      if (!code) return;

      /* 1. Clear any existing discount cookie immediately (sync) */
      document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';

      /* 2. Disable buy buttons until new discount cookie is set */
      function getBuyBtns() {
        return document.querySelectorAll('#nuho-buy-btn-hero, #nuho-buy-btn-mini, [data-product-form-submit], button[name="add"]');
      }
      function setBtnsState(disabled, label) {
        getBuyBtns().forEach(function(b) {
          b.disabled = disabled;
          if (label !== undefined && b.tagName === 'BUTTON') {
            if (disabled) b.dataset.originalLabel = b.textContent;
            b.textContent = disabled ? label : (b.dataset.originalLabel || b.textContent);
          }
        });
      }
      /* Disable now (and again after DOMContentLoaded in case buttons aren't mounted yet) */
      var disable = function() { setBtnsState(true, 'Application de l\'offre…'); };
      disable();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', disable);
      }

      /* 3. Apply new discount via Shopify endpoint */
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin'
      }).finally(function() {
        /* Re-enable buy buttons once cookie is set */
        setBtnsState(false);
      });
    })();

    /* ── Hidden-offer PDP: override displayed price when ?p= query param is present ── */
    (function() {
      var banner = document.getElementById('pdp-offer-banner');
      if (!banner) return;
      var params = new URLSearchParams(window.location.search);
      var p = parseInt(params.get('p'), 10);
      if (!p || p <= 0) return;

      /* Update the main price element */
      var priceEl = document.querySelector('[data-price-display]') || document.querySelector('.pdp__price');
      if (priceEl) {
        var original = priceEl.textContent.trim();
        priceEl.innerHTML = 'CHF ' + p + '.–' +
          '<span class="pdp__price--original-strike">' + original + '</span>';
      }

      /* Update the mini-buy button if present */
      var miniBtn = document.getElementById('nuho-buy-btn-mini');
      if (miniBtn) miniBtn.textContent = 'Acheter : CHF ' + p;

      /* Update the main hero buy button label */
      var mainBtn = document.getElementById('nuho-buy-btn-hero');
      if (mainBtn) mainBtn.textContent = 'Acheter : CHF ' + p + '.–';

      /* Show banner */
      var msg = document.getElementById('pdp-offer-price-text');
      if (msg) msg.textContent = 'Votre prix final : CHF ' + p + '.– (appliqué au checkout)';
      banner.style.display = 'flex';
    })();

    /* Ingredients show-more toggle */
    (function() {
      var btn = document.querySelector('[data-nt-toggle]');
      var extra = document.querySelector('[data-nt-extra]');
      if (!btn || !extra) return;
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) extra.setAttribute('hidden', '');
        else extra.removeAttribute('hidden');
      });
    })();

    /* Thumbnail gallery */
    document.querySelectorAll('.pdp__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var mainImg = document.getElementById('main-product-image');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = thumb.dataset.imageUrl;
            mainImg.style.opacity = '1';
          }, 150);
        }
        document.querySelectorAll('.pdp__thumb').forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
        thumb.classList.add('pdp__thumb--active');
      });
    });

    /* Mobile sticky bar : show when form scrolls out of view */
    var form = document.getElementById('pdp-form');
    var sticky = document.querySelector('[data-pdp-sticky]');
    if (form && sticky) {
      var obs = new IntersectionObserver(function(entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(form);

      /* Sticky bar add-to-cart */
      var stickyBtn = sticky.querySelector('[data-pdp-sticky-add]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function() {
          var formData = new FormData(form);
          var data = {};
          formData.forEach(function(v, k) { data[k] = v; });
          var item = { id: parseInt(data.id, 10), quantity: parseInt(data.quantity, 10) || 1 };
          if (data.selling_plan && data.selling_plan !== '') {
            item.selling_plan = parseInt(data.selling_plan, 10);
          }
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            if (window.openCartDrawer) window.openCartDrawer();
          });
        });
      }
    }

    /* ── Scroll to reviews if #nuho-reviews or #jdgm-widget hash present ── */
    if (window.location.hash === '#nuho-reviews' || window.location.hash === '#jdgm-widget') {
      setTimeout(function() {
        var widget = document.getElementById('nuho-reviews');
        if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }

    /* ── Auto-open review form if #write-review hash present ── */
    if (window.location.hash === '#write-review') {
      var attempts = 0;
      var tryOpen = function() {
        var widget = document.getElementById('nuho-reviews');
        var formWrap = document.getElementById('nuho-rev-form-wrap');
        var toggleBtn = document.getElementById('nuho-rev-toggle');
        if (formWrap) {
          if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          formWrap.style.display = 'block';
          if (toggleBtn) toggleBtn.textContent = '{{ "reviews.cancel" | t | default: "Cancel" }}';
        } else if (attempts < 20) {
          attempts++;
          setTimeout(tryOpen, 300);
        }
      };
      setTimeout(tryOpen, 500);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Quantity buttons
  document.querySelectorAll('.product__quantity-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.product__quantity-field');
      const currentValue = parseInt(input.value) || 1;
      if (btn.dataset.action === 'increase') {
        input.value = currentValue + 1;
      } else if (btn.dataset.action === 'decrease' && currentValue > 1) {
        input.value = currentValue - 1;
      }
    });
  });

  // Thumbnail gallery
  document.querySelectorAll('.product__thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImage = document.getElementById('main-product-image');
      if (mainImage) {
        mainImage.src = thumb.dataset.imageUrl;
      }
      document.querySelectorAll('.product__thumbnail').forEach(t => t.classList.remove('product__thumbnail--active'));
      thumb.classList.add('product__thumbnail--active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('#science');
    if (!section) return;

    var modal = section.querySelector('[data-science-modal]');
    var translations = {};

    // Parse translations from JSON script tag
    var jsonEl = section.querySelector('[data-nutrient-translations]');
    if (jsonEl) {
      try { translations = JSON.parse(jsonEl.textContent); } catch(e) {}
    }

    // Mobile expand/collapse
    var showLabel = section.getAttribute('data-show-label') || 'Show';
    var hideLabel = section.getAttribute('data-hide-label') || 'Hide';
    var expandBtns = section.querySelectorAll('.sci__expand-btn');
    expandBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var cat = btn.closest('.sci__category');
        var isExpanded = cat.classList.toggle('is-expanded');
        var label = btn.querySelector('[data-expand-label]');
        if (label) label.textContent = isExpanded ? hideLabel : showLabel;
      });
    });

    // Open modal on row click
    section.addEventListener('click', function(e) {
      var row = e.target.closest('[data-nutrient]');
      if (!row) return;

      var id = row.getAttribute('data-nutrient');
      var name = row.getAttribute('data-name');
      var form = row.getAttribute('data-form');
      var amount = row.getAttribute('data-amount');
      var vnr = row.getAttribute('data-vnr');
      var t = translations[id] || {};

      modal.querySelector('[data-modal-name]').textContent = name;
      modal.querySelector('[data-modal-form]').textContent = form;
      modal.querySelector('[data-modal-amount]').textContent = amount;
      modal.querySelector('[data-modal-vnr]').textContent = vnr;
      var what = t.what || '';
      var why = t.why || '';
      var body = t.body || '';
      // Decode any HTML entities that Shopify may inject
      var tmp = document.createElement('textarea');
      tmp.innerHTML = what; what = tmp.value;
      tmp.innerHTML = why; why = tmp.value;
      tmp.innerHTML = body; body = tmp.value;
      modal.querySelector('[data-modal-what]').textContent = what;
      modal.querySelector('[data-modal-why]').textContent = why;
      modal.querySelector('[data-modal-body]').textContent = body;

      modal.style.display = 'flex';
      document.documentElement.classList.add('scroll-lock');
    });

    // Close modal
    function closeModal() {
      modal.style.display = 'none';
      document.documentElement.classList.remove('scroll-lock');
    }

    modal.querySelector('[data-science-modal-close]').addEventListener('click', closeModal);
    modal.querySelector('.sci__modal-backdrop').addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["therapeute-page-v3"]) return;
  try {
    
  (function() {
    /* Toggle password visibility */
    document.querySelectorAll('[data-thera-toggle-pw]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('input');
        input.type = input.type === 'password' ? 'text' : 'password';
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upgrade-therapeute-page"]) return;
  try {
    
(function() {
  var BREVO_KEY = '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';
  var form = document.getElementById('upgrade-form');
  var btn = document.getElementById('upgrade-submit-btn');
  var msg = document.getElementById('upgrade-msg');

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var name = document.getElementById('upgrade-name').value.trim();
    var email = document.getElementById('upgrade-email').value.trim();
    var reason = document.getElementById('upgrade-reason').value.trim();

    if (!name || !email || !reason) return;

    btn.disabled = true;
    btn.querySelector('.upgrade__submit-text').style.display = 'none';
    btn.querySelector('.upgrade__spinner').style.display = 'inline-block';
    msg.style.display = 'none';

    var html = '<h3>Upgrade Request — Thérapeute Pro 30%</h3>' +
      '<p><strong>Name:</strong> ' + name + '</p>' +
      '<p><strong>Email:</strong> ' + email + '</p>' +
      '<p><strong>Reason:</strong></p><p>' + reason.replace(/\n/g, '<br>') + '</p>' +
      '<hr><p><em>If approved, change the tag from <strong>thérapeute-20</strong> to <strong>thérapeute-30</strong> in Shopify.</em></p>';

    fetch('https://api.brevo.com/v3/smtp/email', {
      method: 'POST',
      headers: { 'api-key': BREVO_KEY, 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sender: { name: 'NUHO', email: 'contact@nuho.ch' },
        to: [{ email: 'giovenco.david@gmail.com', name: 'NUHO Support' }],
        replyTo: { email: email, name: name },
        subject: '[Upgrade Request] ' + name + ' — Thérapeute Pro 30%',
        htmlContent: html
      })
    })
    .then(function(r) {
      if (r.ok || r.status === 201) {
        form.reset();
        msg.textContent = 'Your request has been sent! We will review it and get back to you soon.';
        msg.style.color = '#16a34a';
        msg.style.display = '';
      } else {
        return r.json().then(function(d) { throw new Error(d.message || 'Error'); });
      }
    })
    .catch(function(err) {
      msg.textContent = err.message || 'Something went wrong. Please try again.';
      msg.style.color = '#ef4444';
      msg.style.display = '';
    })
    .finally(function() {
      btn.disabled = false;
      btn.querySelector('.upgrade__submit-text').style.display = '';
      btn.querySelector('.upgrade__spinner').style.display = 'none';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
